import { CATEGORY_STYLE, slugify } from "../lib/constants";

export const CategoryBadge = ({ categoria, active = true, onClick, count }) => {
  const s = CATEGORY_STYLE[categoria] || CATEGORY_STYLE.Altro;
  const Tag = onClick ? "button" : "span";
  return (
    <Tag
      data-testid={`category-badge-${slugify(categoria)}`}
      onClick={onClick}
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-semibold transition-all duration-200 ${
        onClick ? "hover:-translate-y-0.5 cursor-pointer" : ""
      } ${active ? "" : "opacity-40"}`}
      style={{ background: s.bg, color: s.text, borderColor: s.border }}
    >
      {categoria}
      {count !== undefined && <span className="font-mono opacity-80">{count}</span>}
    </Tag>
  );
};
